import { render, staticRenderFns } from "./VariantDetailsCreateEditModal.vue?vue&type=template&id=205140e2&"
import script from "./VariantDetailsCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./VariantDetailsCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports